import React, { useContext, useState } from 'react';
import * as R from 'ramda';
import Box from '@mui/material/Box';

import { DrawerContext } from 'common/drawer/DrawerContext';
import { ClickAwayListener, Typography } from '@mui/material';
import { MDialog } from 'common';
import AutoConfigurationStep from './AutoConfigurationStep';
import AutoSummaryStep from './AutoSummaryStep';
import AutoConfirmationStep from './AutoConfirmationStep';

const initialState = {
  inventoryOwner: null,
};

const initialValidationState = {
  fromLocation: '',
  inventoryOwner: '',
  product: '',
  thresholdVolume: '',
  toLocation: '',
  transferVolume: '',
};

const AutoOneToOneDrawer = () => {
  const { setDrawerComponentProps } = useContext(DrawerContext);

  const [step, setStep] = useState(1);
  const [reconsignmentState, setReconsignmentState] = useState(initialState);
  const [comparisonState, setComparisonState] = useState(initialState);

  const [validationMessages, setValidationMessages] = useState(initialValidationState);
  const [confirmDialogOpened, setConfirmDialogOpened] = useState(false);

  const next = () => {
    setStep(R.inc);
  };

  const prev = () => {
    setStep(R.dec);
  };

  const reset = () => {
    setReconsignmentState(initialState);
    setComparisonState(initialState);
    setValidationMessages(initialValidationState);
    setStep(1);
  };

  const closeDrawer = () =>
    setDrawerComponentProps({
      Component: '',
      forceCloseSelector: () => false,
      holdOpenSelector: () => false,
      refreshNotifications: false,
      resetWizard: undefined,
      setCurrentDialogOpen: () => {},
      type: '',
    });

  const onClose = () => {
    if (step === 3 || R.equals(reconsignmentState, comparisonState)) {
      // TODO: Implement the onClose function on parent state
      // onClose();
      closeDrawer();
    } else {
      setConfirmDialogOpened(true);
    }
  };

  return (
    <ClickAwayListener
      mouseEvent="onMouseDown"
      onClickAway={event => {
        // Ignore clicks on snackbar
        const isSnackbarClick = event.target.closest('[aria-describedby*="notistack"]');
        if (isSnackbarClick) {
          return;
        }
        onClose();
      }}
      touchEvent="onTouchStart"
    >
      <Box height={1} width={390}>
        {step === 1 && (
          <AutoConfigurationStep
            next={next}
            onClose={onClose}
            reconsignmentState={reconsignmentState}
            setComparisonState={setComparisonState}
            setReconsignmentState={setReconsignmentState}
            setValidationMessages={setValidationMessages}
            validationMessages={validationMessages}
          />
        )}
        {step === 2 && (
          <AutoSummaryStep
            next={next}
            onClose={onClose}
            prev={prev}
            reconsignmentState={reconsignmentState}
          />
        )}
        {step === 3 && (
          <AutoConfirmationStep
            closeDrawer={closeDrawer}
            reconsignmentState={reconsignmentState}
            reset={reset}
          />
        )}
        <MDialog
          header="Unsaved Changes"
          leftButtonAction={() => {
            setConfirmDialogOpened(false);
            closeDrawer();
          }}
          leftButtonText="Continue"
          open={confirmDialogOpened}
          rightButtonAction={() => setConfirmDialogOpened(false)}
          rightButtonText="Keep Editing"
        >
          <Typography color="textPrimary" component="span" variant="subtitle1">
            Are you sure you want to leave this page? You have unsaved auto reconsignment changes.
          </Typography>
        </MDialog>
      </Box>
    </ClickAwayListener>
  );
};

export default AutoOneToOneDrawer;
